export default {
  AUTH (state) {
    return !!state.uid
  }
}
